export class PriceListItemModel {
  constructor(
    id,
    PartitionKey = PriceListItemModelDefaultPartitionKey,
    PriceListId,
    Type,
    PriceType,
    Value,
    ProductId,
    CustomerId,
    Active,
    CreatedAt = (new Date()).toISOString()
  ) {
    this.id = id;
    this.PartitionKey = PartitionKey;
    this.PriceListId = PriceListId;
    this.Type = Type;
    this.PriceType = PriceType;
    this.Value = Value;
    this.ProductId = ProductId;
    this.CustomerId = CustomerId;
    this.Active = Active;
    this.CreatedAt = CreatedAt
  }
}

export var PriceListItemModelDefaultPartitionKey = "Default";
